import {
  ButtonStyled,
  ModalStyled,
  toggleSiblingNodes,
  IconButton,
  TextStyled,
} from '@nike/nike-design-system-components';
import { Info } from '@nike/nike-design-system-icons';
import PropTypes from 'prop-types';
import React, { useState, Fragment } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { ID_MODAL_ROOT } from '../../utils/dom-element-ids';

function InformationModal({ modalTitle, informationList, iconId }) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
    toggleSiblingNodes(`#${ID_MODAL_ROOT}`, true, undefined);
  };

  const closeModal = () => {
    setIsOpen(false);
    toggleSiblingNodes(`#${ID_MODAL_ROOT}`, false, undefined);
  };

  const infoList = informationList.map(({ item, definition }) => (
    <Fragment key={`info-list-${uuidv4()}`}>
      {item && (
        <TextStyled appearance="heading4" bold="true" display="inline">
          {`${item} `}
        </TextStyled>
      )}
      {definition}
      <br />
    </Fragment>
  ));

  const actions = () => (
    <ModalStyled>
      <ButtonStyled appearance="primary" ariaLabel="close-dialog" onClick={closeModal}>
        Close Dialog
      </ButtonStyled>
    </ModalStyled>
  );
  return (
    <>
      <IconButton
        Icon={<Info />}
        ariaLabel="info button"
        id={iconId}
        size="small"
        type="button"
        onClick={openModal}
      />
      <ModalStyled
        className="dialogModal"
        closeModal={closeModal}
        footerContent={actions}
        isOpen={isOpen}
        slots={{ FooterSlot: actions }}
        title={modalTitle}
      >
        <div className="ta-sm-l">{infoList}</div>
      </ModalStyled>
    </>
  );
}

InformationModal.propTypes = {
  modalTitle: PropTypes.string.isRequired, // Already localized string
  informationList: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.string, // Optional - already localized, displays as bold heading
      definition: PropTypes.string.isRequired, // Required - already localized, main content
    }),
  ).isRequired,
  iconId: PropTypes.string.isRequired,
};

export default InformationModal;
